import React, { useEffect } from 'react';
import { Footer } from './Footer';

const NotFoundPage = () => {

  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="not-found-page" style={{
      zoom: 'normal',
      transform: 'scale(1)',
      width: '100%',
      height: '100%',
      overflow: 'visible'
    }}>
      <div className="process-page">
        {/* Logo Header */}
        <div className="telematics-header">
          <div className="container">
            <div className="logo-container">
              <a href="/">
                <img 
                  src="/img/Banner_16x_TR_Trim&ColorEdit.png" 
                  alt="Yuccan Technologies Logo" 
                  className="telematics-logo"
                />
              </a>
            </div>
          </div>
        </div>
        
        {/* Hero Section */}
        <section className="process-hero" style={{minHeight: '100vh', position: 'relative'}}>
          {/* Background Image */}
          <div style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundImage: 'url(/img/404-notfound.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            top: 0,
            left: 0,
            zIndex: -1
          }} />
          
          <div className="hero-overlay">
            <div className="container">
              <div className="row">
                <div className="col-md-6" style={{marginTop: '300px'}}>
                  <div className="hero-content-overlay">
                    <div className="hero-two-column">
                      <div className="hero-left-column">
                        {/* Error Message */}
                        <h1 className="hero-title text-primary" style={{marginBottom: '10px', marginTop: '0px', fontSize: '4.5rem'}}>
                          Oops! This page<br />
                          does not exist
                        </h1>
                        
                        <p style={{marginTop: '0px', marginBottom: '20px', fontSize: '20px', lineHeight: '1.6', color: 'black', textAlign: 'justify'}}>
                          The page you're looking for might have been moved, deleted, or you entered the wrong URL. 
                          Don't worry, it happens to the best of us!
                        </p>
                      </div>
                      
                      <div className="hero-right-column" style={{paddingRight: '5px'}}>
                        {/* Action Buttons */}
                        <div className="hero-cta">
                          <button
                            onClick={handleGoBack}
                            className="btn btn-outline-primary btn-lg"
                          >
                            Go Back
                          </button>
                        </div>

                        {/* Popular Links */}
                        <div style={{marginTop: '20px'}}>
                          <div style={{
                            fontSize: '19px',
                            color: '#2B4B8C',
                            marginBottom: '5px',
                            fontWeight: '600',
                            textAlign: 'center'
                          }}>
                            Popular Pages
                          </div>
                          <div style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '8px'
                          }}>
                            <div style={{
                              color: '#2B4B8C',
                              fontSize: '14px',
                              padding: '8px',
                              borderRadius: '15px',
                              backgroundColor: 'rgba(255, 255, 255, 0.2)',
                              textAlign: 'center',
                              height: '30px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer'
                            }}><a href="/telematics" style={{color: 'inherit', textDecoration: 'none'}}>
                              Vehicle Telematics
                            </a></div>
                            <div style={{
                              color: '#2B4B8C',
                              fontSize: '14px',
                              padding: '8px',
                              borderRadius: '15px',
                              backgroundColor: 'rgba(255, 255, 255, 0.2)',
                              textAlign: 'center',
                              height: '30px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer'
                            }}><a href="/dynamic-pricing" style={{color: 'inherit', textDecoration: 'none'}}>
                              Dynamic Pricing
                            </a></div>
                            <div style={{
                              color: '#2B4B8C',
                              fontSize: '14px',
                              padding: '8px',
                              borderRadius: '15px',
                              backgroundColor: 'rgba(255, 255, 255, 0.2)',
                              textAlign: 'center',
                              height: '30px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer'
                            }}><a href="/remote-assets" style={{color: 'inherit', textDecoration: 'none'}}>
                              Remote Assets
                            </a></div>
                            <div style={{
                              color: '#2B4B8C',
                              fontSize: '14px',
                              padding: '8px',
                              borderRadius: '15px',
                              backgroundColor: 'rgba(255, 255, 255, 0.2)',
                              textAlign: 'center',
                              height: '30px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer'
                            }} onClick={() => {
                              // Use the session-based navigation system
                              sessionStorage.setItem('scrollTarget', '#contact');
                              window.location.href = '/';
                            }}>
                              Contact Us
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      
      {/* Universal Footer */}
      <Footer />
    </div>
  );
};

export default NotFoundPage;